//import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
  basecontent: {
    backgroundColor: "theme.palette.background.default", 
    '@media only screen and (max-width: 400px)': {
      backgroundColor: 'white',
    }, 
  },  
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
    width: 400,
    '@media only screen and (max-width: 600px)': {
      boxShadow: 'none',
      width: 300,
      marginTop:0,
      marginRight:"auto",
      marginBottom:0,
      marginLeft:"auto", 
    }
  },
  root_text_container: {
    float: "right",
    '@media only screen and (max-width: 600px)': {
      float: "none",
    }  
  },
  root_text: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
    width: 350,
    '@media only screen and (max-width: 600px)': {
      boxShadow: 'none',
      width: 300,
      marginTop:0,
      marginRight:"auto",
      marginBottom:0,
      marginLeft:"auto",
    }    
  },  
  root_md: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
    width: 400,
    '@media only screen and (max-width: 600px)': {
      width: 300,
      boxShadow: 'none',
    }
  },
  stepper: {
    width:780, 
    backgroundColor:'transparent',
    '@media only screen and (max-width: 600px)': {
      width: '190%',
    }    
  },
  header: {
    textAlign: 'center'
  },
  logoContainer: {
    marginBottom: theme.spacing(2),
  },
  largeLogo: {
    height: 50,
  },
  button: {
    margin: theme.spacing(1),
    textTransform: "none"
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
  leftButton: {
    marginLeft: theme.spacing(-2),
  },
  rightButton: {
    marginRight: 0,
  },
  leftDiv: {
    float: 'left',
    textAlign: 'left',
  },
  rightDiv: {
    float: 'right',
  },
  socialTextContainer: {
    clear: 'both',
    backgroundColor: 'white',
    textAlign: 'center',
    margin: 0,
    paddingTop: 20,
    paddingBottom: 0,
  },
  socialButtonContainer: {
    justifyContent: 'center',
    textAlign: 'center',
    margin: 0,
  },
  socialIcon: {
    height: 20,
    marginRight: theme.spacing(1),
  },
  socialButton: {
    width: 250,
    backgroundColor: '#ffffff',
  },
  needAccountContainer: {
    textAlign: 'center',
  },
  inputCenter: {
    textAlign: "center",
  }
});